import { Time } from "@/utils/unit";
import { QueryClient } from "@tanstack/react-query";

export const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Time.minutes(5),
      gcTime: Time.minutes(10),
    },
  },
});
